import React, { Component } from 'react';
import './ImportUsersPopup.css';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Button from '../../components/button/Button';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';

export default class ImportUsersPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uploading: false,
			parsing: false,
			users: null,
			importing: false,
			adminUsers: {},
			selectedAdminUserId: -1
		};
		this.fileInputRef = React.createRef();
	}

	componentDidMount = async () => {
		await this._loadAdminUsers();
	};

	_loadAdminUsers = async () => {
		const { userGroupId } = this.props;
		if (!userGroupId) return;

		try {
			const allUsers = await mainAPI.user.for_group(userGroupId);
			const adminUsers = {};
			
			if (Array.isArray(allUsers)) {
				allUsers.forEach(user => {
					if (user.role === 'admin' || user.role === 'super_admin') {
						adminUsers[user.id] = {
							id: user.id,
							name: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.primary_email,
							value: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.primary_email
						};
					}
				});
			}

			this.setState({ adminUsers });
		} catch (error) {
			console.error('Error loading admin users:', error);
		}
	};

	_handleFileSelect = () => {
		if (this.fileInputRef.current) {
			this.fileInputRef.current.click();
		}
	};

	_handleFileChange = async (event) => {
		const file = event.target.files?.[0];
		if (!file) return;

		const { userGroupId } = this.props;
		if (!userGroupId) {
			toasts.show('Invalid user group ID');
			return;
		}

		this.setState({ parsing: true });

		const formData = new FormData();
		formData.append('file', file);
		formData.append('user_group_id', userGroupId);

		try {
			const response = await mainAPI.user.parseImportFile(formData);
			if (response && Array.isArray(response) && response.length > 0) {
				this.setState({ users: response, parsing: false });
				toasts.show(`Found ${response.length} user(s) in file`);
			} else if (response && response.data && Array.isArray(response.data)) {
				this.setState({ users: response.data, parsing: false });
				toasts.show(`Found ${response.data.length} user(s) in file`);
			} else {
				this.setState({ parsing: false });
				toasts.show('No users found in file');
			}
		} catch (error) {
			console.error('Error parsing file:', error);
			toasts.show('Failed to parse file');
			this.setState({ parsing: false });
		} finally {
			if (this.fileInputRef.current) {
				this.fileInputRef.current.value = '';
			}
		}
	};

	_handleImport = async () => {
		const { users, selectedAdminUserId } = this.state;
		const { userGroupId, onComplete } = this.props;

		if (!users || users.length === 0) {
			toasts.show('No users to import');
			return;
		}

		if (selectedAdminUserId === -1) {
			toasts.show('Please select an admin user');
			return;
		}

		this.setState({ importing: true });

		try {
			await mainAPI.user.importUsers({ 
				user_group_id: userGroupId, 
				users,
				admin_user_id: selectedAdminUserId
			});
			toasts.show(`Successfully imported ${users.length} user(s)`);
			if (onComplete) {
				onComplete();
			}
			this.props.onClose();
		} catch (error) {
			console.error('Error importing users:', error);
			toasts.show('Failed to import users');
		} finally {
			this.setState({ importing: false });
		}
	};

	_onAdminUserChange = (adminUserId) => {
		this.setState({ selectedAdminUserId: adminUserId });
	};

	_renderUsers = () => {
		const { users } = this.state;
		if (!users || users.length === 0) return null;

		return (
			<div className="import-users-list">
				<Label black large>Users to Import ({users.length})</Label>
				<div className="users-table">
					<div className="users-header">
						<Label black>Email</Label>
						<Label black>First Name</Label>
						<Label black>Last Name</Label>
						<Label black>Role</Label>
					</div>
					{users.map((user, index) => (
						<div className="users-row" key={index}>
							<Label>{user.primary_email || ''}</Label>
							<Label>{user.first_name || ''}</Label>
							<Label>{user.last_name || ''}</Label>
							<Label>{user.role || 'user'}</Label>
						</div>
					))}
				</div>
			</div>
		);
	};

	render() {
		const { parsing, users, importing } = this.state;
		const { onClose, show } = this.props;
		let showProp = show;
		if (!this.props.hasOwnProperty('show')) {
			showProp = true;
		}

		return (
			<Popup {...this.props} show={showProp} className="g-import-users-popup">
				<Card>
					<Label black large className="label">
						Import Users
					</Label>
					<div className="content">
						<div className="admin-user-selector">
							<Label black>Select Admin User</Label>
							<UniversalDropDown
								options={this.state.adminUsers}
								placeholder="Select an admin user"
								value={this.state.selectedAdminUserId}
								onChange={this._onAdminUserChange}
								required
							/>
						</div>
						<input
							ref={this.fileInputRef}
							type="file"
							accept=".xlsx,.xls,.csv"
							style={{ display: 'none' }}
							onChange={this._handleFileChange}
						/>
						{!users && (
							<Button
								color="white"
								bg="blue"
								onClick={this._handleFileSelect}
								disabled={parsing}
							>
								{parsing ? 'Parsing...' : 'Select Excel or CSV File'}
							</Button>
						)}
						{this._renderUsers()}
					</div>
					<div className="actions">
						<Button color="white" bg="red" onClick={onClose}>
							Cancel
						</Button>
						{users && users.length > 0 && (
							<Button
								color="white"
								bg="blue"
								onClick={this._handleImport}
								disabled={importing}
							>
								{importing ? 'Importing...' : 'Import Users'}
							</Button>
						)}
					</div>
				</Card>
			</Popup>
		);
	}
}




// WEBPACK FOOTER //
// ./src/popups/importUsersPopup/ImportUsersPopup.jsx